import api from '../../utils/axios.js';

const expertHasSkills = async (expertId) => {
	const { data } = await api.get(`/experts/${expertId}/skills`);

	return data;
};

const skillsServices = {
	expertHasSkills,
};

export default skillsServices;
